<template>
  <div style="height:100%">
    <vue-element-loading :active="isActive" :is-full-screen="true" spinner="bar-fade-scale" color="#007bce"/>
    <router-view />
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import { mapState } from 'vuex';
export default {
  name: 'App',
  data(){
    return {
      isActive: false,
    }
  },
  components: { VueElementLoading },
  watch: {
    loadBody: function(newValue){
      this.isActive = newValue;
    }
  },
  computed: {
    ...mapState('layout', ['loadBody']),
  },
  created() {
    this.isActive = true;
    const currentPath = this.$router.history.current.path;
    if (!window.localStorage.getItem('auth_token')) {
      this.$router.push('/login');
      return;
    }
  },
  mounted(){
    this.isActive = false;
  }
};
</script>

<style src="./styles/theme.scss" lang="scss" />
